module.exports = __webpack_public_path__ + "static/media/image_40.5713f2fc.png";